module.exports = __webpack_public_path__ + "img/scalpel.59b7bb75.svg";